<template>
  <div>
    <div class="md-body-2">
      <p>
        Onderstaand uw licentiegegevens.<br /> Voor wijzigingen, <a :href="`mailto:${$infoMail}?subject=Wijzigen licentiegegevens&body=Klantnummer: ${loginName}%0D%0A%0D%0AGraag wijzigen:%0D%0A`">klik hier</a> of stuur een e-mail naar {{ $infoMail }}.
      </p>
    </div>
    <listview :vm="listVm" hide-year-filter />
  </div>
</template>

<script>
  import Listview from '@/components/base/Listview';
  import ListVm from '@/components/base/ListVm';
  import Format from '@/format';

  const _comp = {
    name: 'Licenties',
    data: () => ({
      listVm: null,
      loginName: null
    }),
    created() {
      this.listVm = new ListVm(
        'Licenties',
        'LicenseNo',
        (ctx) => `/odata/Licence`,
        ['LicenseDueDate', 'LicenseDateOfBirth', 'CancelledDate'],
        (srch, items) => items.filter(i => `${i.LicenseType}${i.LicenseNo}${i.LicenseName}`.toLowerCase().indexOf(srch.toLowerCase()) != -1),
        (item) => { },
        [
          { name: 'Type', sort: 'LicenseType', select: i => i.LicenseType, style: 'font-weight:bold;' },
          { name: 'Nr.', sort: 'LicenseNo', select: i => i.LicenseNo },
          { name: 'Naam', sort: 'LicenseName', select: i => i.LicenseName },
          { name: 'Geboortedatum', sort: 'LicenseDateOfBirth', select: i => Format.date(i.LicenseDateOfBirth) },
          { name: 'Vervaldatum', sort: 'LicenseDueDate', select: i => Format.date(i.LicenseDueDate) },
          { name: 'Vervallen', sort: 'Cancelled', select: i => i.Cancelled ? 'Ja' : 'Nee' },
        ]
      );

      global.Auth.GetToken()
        .then(tok => {
          this.loginName = tok.sub;
        });
    },
    components: {
      'listview': Listview
    }
  };

  export default _comp;
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Licenties.vue